import {ITableActionProps} from '../table-action-types';
import {GenerateTcResponse, IGenerateTcResponseProps} from './generate-tc-response';

export const GenerateTcResponseNoRedirect = ({
    wrapper,
    meta,
}: ITableActionProps) => (
    GenerateTcResponse({
        wrapper,
        meta,
        withRedirect: false,
    } as IGenerateTcResponseProps)
);
